document.addEventListener('DOMContentLoaded', function () {
  initCpReveal();
  initCpMarquee();
});

function initCpReveal() {
  var els = document.querySelectorAll('.cp-reveal');
  if (!els.length) return;

  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('cp-visible'); });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('cp-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
  );

  els.forEach(function (el) { observer.observe(el); });
}

function initCpMarquee() {
  var tracks = document.querySelectorAll('[data-cp-marquee-track]');
  if (!tracks.length) return;

  tracks.forEach(function (track) {
    if (track.dataset.cpDuplicated) return;
    track.innerHTML += track.innerHTML;
    track.dataset.cpDuplicated = 'true';
  });
}
